import React from 'react';
import { BarChart3, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const DocumentReports = () => {
  return (
    <div className="document-reports" style={{ fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif' }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6">
          <Link 
            to="/collaboration/documents" 
            className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-4"
          >
            <ArrowLeft size={20} className="mr-2" />
            Back to Document Library
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">Document Reports</h1>
          <p className="text-gray-600 mt-2">
            Generate comprehensive reports on document usage.
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="text-center py-12">
            <div className="bg-orange-100 p-4 rounded-2xl w-fit mx-auto mb-6">
              <BarChart3 size={48} className="text-orange-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Document Analytics</h2>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              Comprehensive document usage reports with analytics and insights. 
              This feature will be available in v1.1.
            </p>
            
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <p className="text-yellow-800 text-sm">
                <strong>Coming Soon:</strong> Advanced document analytics with usage tracking, 
                collaboration metrics, and content insights.
              </p>
            </div>

            <button className="bg-orange-600 text-white px-6 py-3 rounded-lg hover:bg-orange-700 transition-colors flex items-center mx-auto">
              <BarChart3 size={20} className="mr-2" />
              Generate Report
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentReports;
